export default __webpack_public_path__ + "static/media/サービス利用規約_ver7.ad7906ad.pdf";